import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal } from "./Reveal";

const STATS = [
    { value: 1246, prefix: "", suffix: "", label: "Units Under Management" },
    { value: 23, prefix: "+", suffix: "%", label: "Avg. NOI Growth in 12 Months" },
    { value: 5, prefix: "", suffix: "", label: "Sunbelt Regions" },
    { value: 8, prefix: "", suffix: "", label: "Operating Disciplines" },
];

const CountUp = ({ value, prefix, suffix }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-40px" });
    const [display, setDisplay] = useState(0);

    useEffect(() => {
        if (!inView) return;
        const controls = animate(0, value, {
            duration: 1.8,
            ease: [0.22, 1, 0.36, 1],
            onUpdate: (v) => setDisplay(Math.round(v)),
        });
        return () => controls.stop();
    }, [inView, value]);

    return (
        <span ref={ref}>
            {prefix}
            {display.toLocaleString()}
            {suffix}
        </span>
    );
};

export default function Stats() {
    return (
        <section
            data-testid="stats-section"
            className="border-y border-white/10 bg-[#060C1B] py-14 lg:py-16"
        >
            <div className="mx-auto grid max-w-7xl grid-cols-2 gap-10 px-5 sm:px-8 lg:grid-cols-4 lg:px-12">
                {STATS.map((s, i) => (
                    <Reveal key={s.label} delay={i * 0.08}>
                        <div data-testid={`stat-${i + 1}`} className="text-center lg:text-left">
                            <p className="font-display text-4xl font-extrabold tracking-tight text-white sm:text-5xl">
                                <span className="text-[#1BA8E0]">
                                    <CountUp value={s.value} prefix={s.prefix} suffix={s.suffix} />
                                </span>
                            </p>
                            <p className="mt-3 text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-500">
                                {s.label}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
